module.exports = __webpack_public_path__ + "img/02.55c5621a.jpg";